import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { iesLogin, iesLogout } from "./service.js";
import { setToken, getUser, setHeader, getTranslation } from "../service/service.js";
import { fetchSponteAlunoId, fetchAllSponteAlunoIds } from "./sponte_service.js";
import { getWizmeIdFromIESCode } from "./wizme_auth_service.js";
import cookie from "react-cookies";

// IES NEW CODE
import {redirectToIESLogin} from "./auth_service_ies.js"
import styles from "../assets/containers/FullPageLoader.module.css";
import {EagleIcon} from "../components/EagleIcon"

import qs from 'qs'

const AuthCallback = () => {
    const history = useHistory();

    useEffect(() => {
        const is_container_environment = process.env.REACT_APP_IS_CONTAINER_ENVIRONMENT;
        const authenticate = async () => {
            try {
                const hash = window.location.hash;
                const queryString = hash.includes('?') ? hash.split('?')[1] : '';
                const params = new URLSearchParams(queryString);

                const code = params.get("code");
                const receivedState = params.get("state");
                const expectedState = sessionStorage.getItem("oauth_state");

                if (!code) {
                console.error("Code not found in URL.");
                history.push("/");
                return;
                }

                if (!receivedState || receivedState !== expectedState) {
                console.error("Incorrect state!");
                history.push("/");
                return;
                }
                
                const redirect_uri = is_container_environment === 'false' ? `${window.location.origin}/catchup/login_callback` : `${window.location.origin}/login_callback`;

                // --- Wizme BFF + IES login in parallel ---
                // Both calls use the same IES authorization code. Running them in parallel
                // avoids a sequential code-consumption race condition.
                // Mirrors the mobile (wiztab) approach from PR #16 / ARTFRAN-11130.
                const [iesResult, wizmeResult] = await Promise.allSettled([
                    iesLogin({ code, redirect_uri }),
                    getWizmeIdFromIESCode(code, redirect_uri),
                ]);

                if (iesResult.status === 'rejected') {
                    throw iesResult.reason;
                }

                const responseIES = iesResult.value;
                const wizmeId = wizmeResult.status === 'fulfilled' ? wizmeResult.value : null;
                // --- End Wizme BFF ---

                if (responseIES.user_exists == false) {
                    redirectToIESLogin()
                }

                setToken(responseIES);

                let stringifiedToken = JSON.stringify(responseIES);
                setHeader(responseIES.oauth_data.token_type, responseIES.access_token);
                cookie.save("token_info", stringifiedToken, { path: "/" });

                let getUserInfo = await getUser()

                // --- Sponte: buscar alunoId pelo email para usar no progresso ---
                var userEmail = (getUserInfo && getUserInfo.data && getUserInfo.data.email) || (getUserInfo && getUserInfo.email);
                if (userEmail) {
                    try {
                        // Fetch ALL Sponte alunoIds (active + inactive) so that progress
                        // stored under an older record (before unit transfer or credential
                        // unification) can still be found via the fallback in getAllUserIds().
                        var sponteIds = await fetchAllSponteAlunoIds(userEmail);
                        if (sponteIds.length > 0) {
                            if (getUserInfo && getUserInfo.data) {
                                getUserInfo.data.sponteId = sponteIds[0];   // primary (active) for writes
                                getUserInfo.data.sponteIds = sponteIds;     // all IDs for progress fallback reads
                            } else {
                                getUserInfo.sponteId = sponteIds[0];
                                getUserInfo.sponteIds = sponteIds;
                            }
                        }
                        console.log("Sponte alunoIds resolved:", sponteIds);
                    } catch (sponteError) {
                        console.warn("Could not fetch Sponte alunoIds, progress will use IES id only:", sponteError);
                    }
                }
                // --- End Sponte ---

                // --- Wizme: persist platformId on user-info ---
                if (wizmeId) {
                    if (getUserInfo && getUserInfo.data) {
                        getUserInfo.data.wizmeId = wizmeId;
                    } else if (getUserInfo) {
                        getUserInfo.wizmeId = wizmeId;
                    }
                    console.log("Wizme ID resolved:", wizmeId);
                }
                // --- End Wizme ---

                // Limpar dados anteriores como o login antigo faz (login.js L63-64)
                localStorage.removeItem('languagePack');
                localStorage.removeItem('currentBookId');
                // Clear stale user-info immediately so that, if any subsequent
                // async step fails, no previous student's profile is exposed.
                // This is especially important for LGPD compliance: a different
                // student must never see another student's name or books.
                localStorage.removeItem('user-info');

                localStorage.setItem('user-info', JSON.stringify(getUserInfo));
                localStorage.setItem('token_info_hint', JSON.stringify(responseIES.oauth_data.id_token));

                localStorage.setItem('userFromIES', true)

                // --- Language: replicar comportamento do login antigo ---
                // Se o usuario tem mais de 1 idioma, NAO setar languagePack.
                // O header.js detecta isso e abre o modal SelectLanguage automaticamente.
                // Se tem exatamente 1 idioma, setar o languagePack normalmente.
                var userData = (getUserInfo && getUserInfo.data) || getUserInfo;
                var availableLanguages = userData && userData.available_languages;
                if (availableLanguages && availableLanguages.length === 1) {
                    var languageCode;
                    var regionUser = userData.region_user;
                    var regionCode = userData.region_code;
                    if (regionUser && regionUser !== 'BRA' && availableLanguages[0].code === 'en') {
                        languageCode = regionCode;
                    } else {
                        languageCode = availableLanguages[0].code;
                    }
                    try {
                        var translationRes = await getTranslation(languageCode);
                        var languagePack = translationRes.data || translationRes;
                        languagePack.selectedLanguage = availableLanguages[0].code;
                        languagePack.languageCode = languageCode;
                        localStorage.setItem('languagePack', JSON.stringify(languagePack));
                        console.log("Language pack set:", languageCode);
                    } catch (langErr) {
                        console.warn("Could not fetch translation, defaulting to en:", langErr);
                    }
                } else if (availableLanguages && availableLanguages.length > 1) {
                    console.log("Multiple languages available, deferring to SelectLanguage modal");
                }
                // --- End Language ---

                history.push("/#/catchup/classes/list");
                window.location.reload();
            } catch (error) {
                console.error("Authentication error:", error);
                // Redirect back to login instead of leaving the user stuck on
                // the loader screen indefinitely (ARTFRAN-12269).
                history.push("/");
            }
        };

        authenticate();
    }, [history]);

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-100 bg-opacity-70 z-50">
            <div className="d-flex justify-content-center align-items-center vh-100">
                {/*<div className="animate-spin rounded-full h-24 w-24 border-t-2 border-b-2 border-black"/>*/}
                <div className={styles.loaderContainer}>
                    <div className={styles.loaderCenter}/>
                    <div className={styles.loaderWheel}/>
                    <EagleIcon className={styles.loaderEagle}/>
                </div>
            </div>
        </div>
    )
};

export default AuthCallback;
 